import React from 'react';
import Filters from '../Filters';
import PropTypes from 'prop-types';
import Select from 'react-select';
import FilterDate from '../../DateRangeComponent/DateRange';

import './FilterMainCampaign.css';
import 'react-select/dist/react-select.css';

export default class FilterMainCampaign extends Filters {
  static propTypes = {
    className: PropTypes.string,
    changeFilter: PropTypes.func,
    getCampaignData: PropTypes.func,
    getOperatorData: PropTypes.func,
    filters: PropTypes.obj,
    campaignData: PropTypes.array,
    operatorData: PropTypes.array,
    initialValues: PropTypes.obj
  };

  componentDidMount(){
    if (this.props.initialValues) {
      this.props.changeFilter(this.props.initialValues);
      this.props.getCampaignData(this.props.initialValues);
      this.props.getOperatorData(this.props.initialValues);
    } else {
      this.props.getCampaignData(this.props.filters);
      this.props.getOperatorData(this.props.initialValues);
    }
  }

  onItemChange = (field) => (selectedItem) => {
    if(selectedItem) {
      var newFilters
      if (selectedItem.target && selectedItem.target.placeholder === "CampaignId"){
        newFilters = {
          [field]: selectedItem.target.value ? selectedItem.target.value : selectedItem
        };
      } else {
        newFilters = {
          ...this.props.filters,
          [field]: selectedItem.value ? selectedItem.value : selectedItem
        };
      }
      this.props.changeFilter(newFilters);
      this.props.getCampaignData(newFilters);
      this.props.getOperatorData(newFilters);
    } else { // if its a clear operation
      const { [field]: omitThis, ...newFilters } = this.props.filters;
      //Clear campaign from filters if any other field is cleared
      delete newFilters.campaignId
      //Clear operator if country is cleared
      if(field === "countryId") {
        delete newFilters.oc;
      }
      this.props.changeFilter(newFilters);
      this.props.getCampaignData(newFilters);
      this.props.getOperatorData(newFilters);
    }
  }

  onDatesChange = ({startDate, endDate}) => {
    const newFilters = {
      ...this.props.filters,
      startDate: startDate ? startDate.format() : startDate,
      endDate: endDate ? endDate.format() : endDate
    };
    this.props.changeFilter(newFilters)
  }

  render() {
    const countries = this.props.operatorData ? this.props.operatorData.reduce((countriesCurr, operator) => ({
      ...countriesCurr,
      [operator.countryId]: operator.countryName
    }), {}) : {};

    let countriesMaped = Object.keys(countries).map(value => ({ value, label: countries[value] }))

    if(this.props.campaignData.length === 1 && this.props.campaignData[0].countryId && countries[this.props.campaignData[0].countryId]) {
      countriesMaped = countriesMaped.filter(item => {
        if ((item.value) && (item.value === this.props.campaignData[0].countryId.toString())) {
          return true;
        }
      })
    }
    if(!this.props.filters.countryId && countriesMaped && countriesMaped.length === 1) {
      this.props.filters.countryId = countriesMaped[0].value;
      this.props.changeFilter(this.props.filters);
      this.props.getCampaignData(this.props.filters);
      this.props.getOperatorData(this.props.filters);
    }

    let operatorsFiltered = []
    let operators = this.props.filters && this.props.filters.countryId ? this.props.operatorData.map(operator => ({ value: operator.oc, label: operator.operatorName })) : [];
    if(this.props.campaignData.length === 1 && this.props.campaignData[0].operators.length !== 0 ) {
      operators = operators.filter(item => {
        this.props.campaignData[0].operators.forEach(i => {
          if ((item.value) && (item.value === i.id)) operatorsFiltered.push(item);
        })
      })
    }

    if(!this.props.filters.oc && operatorsFiltered && operatorsFiltered.length === 1) {
      this.props.filters.oc = operatorsFiltered[0].value
      this.props.changeFilter(this.props.filters);
      this.props.getCampaignData(this.props.filters);
      this.props.getOperatorData(this.props.filters);
    }

    let services = this.props.filters && this.props.filters.oc && this.props.operatorData.length ? this.props.operatorData[0].services.map(service => ({ value: service.id, label: service.name })) : [];
    if(this.props.campaignData.length === 1 && this.props.campaignData[0].serviceId) {
      services = services.filter(item => {
        if ((item.value) && (item.value === this.props.campaignData[0].serviceId.toString())) {
          return true;
        }
      })
    }

    if(!this.props.filters.service && services && services.length === 1) {
      this.props.filters.service = services[0].value
      this.props.changeFilter(this.props.filters)
    }

    return (
      <div className={`FilterMainCampaign ${this.props.className ? this.props.className : ''}`}>
        <input
        type="text"
        className="input"
        placeholder="CampaignId"
        value={this.props.campaignId}
        onChange={this.onItemChange('campaignId')}
        />
        <Select
          name="form-field-name"
          value={this.props.filters.countryId}
          placeholder="Country"
          className="select"
          onChange={this.onItemChange('countryId')}
          options={countriesMaped}
          isLoading={this.props.loading && !this.props.filters.countryId}
        />
        <Select
          name="form-field-name"
          value={this.props.filters.oc}
          placeholder="Operator"
          className="select"
          onChange={this.onItemChange('oc')}
          options={operatorsFiltered.length !== 0 ? operatorsFiltered : operators}
          isLoading={this.props.loading && !this.props.filters.oc}
        />
        <Select
          name="form-field-name"
          value={this.props.filters.service}
          placeholder="Services"
          className="select"
          onChange={this.onItemChange('service')}
          options={services.length > 1 ? [
            { value: '*', label: 'All Services' },
            ...services
          ] : services}
          isLoading={this.props.loading && !this.props.filters.service}
        />
        <FilterDate
          startDate={this.props.filters.startDate}
          endDate={this.props.filters.endDate}
          onChange={this.onDatesChange}
        />
        <Select
          name="form-field-name"
          value={this.props.filters.tz || 'GMT'}
          placeholder="TZ"
          className="select-tz"
          onChange={this.onItemChange('tz')}
          options={[
            { value: 'GMT', label: 'AE' },
            { value: 'Pacific/Tahiti', label: 'TX' },
            { value: 'Asia/Dubai', label: 'SG' },
          ]}
          clearable={false}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filters/FilterCampaignComponent/FilterMainCampaign.js